import {IAuthToken, IInputLogin, IInputPassword, IUser} from 'MyModels';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {IResponse20x, RxAxios} from '../shared';

export class AuthService {
  // private user?: IUser;
  private readonly KEY_TOKEN = 'SEI_POCKET_TOKEN_JWT';
  private readonly KEY_TTL = 'SEI_POCKET_TOKEN_JWT_TTL';

  constructor(protected api: RxAxios) {}

  public signIn(input: IInputLogin): Observable<IAuthToken> {
    return this.api
      .post<IResponse20x>('/mod/participants/auth/login', input)
      .pipe(map(result => result.data));
  }

  public requestLogout(): Observable<boolean> {
    return this.api.post<IResponse20x>('/mod/participants/auth/logout').pipe(
      tap(() => this.removeToken()),
      map(result => result.status === 'success')
    );
  }

  public me(): Observable<IUser> {
    return this.api
      .get<IResponse20x>('/mod/participants/me')
      .pipe(map(result => result.data));
  }

  public updatePassword(input: IInputPassword): Observable<IUser> {
    return this.api
      .put<IResponse20x>('/mod/participants/me', input)
      .pipe(map(result => result.data));
  }

  public setToken(token: IAuthToken): void {
    localStorage.setItem(this.KEY_TTL, token.expires_in.toString());
    localStorage.setItem(this.KEY_TOKEN, token.access_token);
    this.api.setToken(token.access_token);
  }

  public removeToken(): void {
    // this.user = undefined;
    localStorage.removeItem(this.KEY_TTL);
    localStorage.removeItem(this.KEY_TOKEN);
  }

  // public setUser(user: IUser): void {
  //   this.user = user;
  // }

  // public getUser(): IUser | undefined {
  //   return this.user;
  // }

  public isAuthenticated(): boolean {
    return !!localStorage.getItem(this.KEY_TOKEN);
  }
}



// WEBPACK FOOTER //
// ./src/services/auth-service.ts